import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';
import ClosureList from './ClosureList';

const ClosureListPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContent title={t('closures.list.title')}>
      <ClosureList />
    </PageContent>
  );
};
export default ClosureListPage;
